/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Pozemky_CzInputs */

const cs_enum_pozemky_cz = /** @type {(inputs: Enum_Pozemky_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozemky.cz`)
};

const en_enum_pozemky_cz = /** @type {(inputs: Enum_Pozemky_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozemky.cz`)
};

/**
* | output |
* | --- |
* | "Pozemky.cz" |
*
* @param {Enum_Pozemky_CzInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_pozemky_cz = /** @type {((inputs?: Enum_Pozemky_CzInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Pozemky_CzInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_pozemky_cz(inputs)
	return cs_enum_pozemky_cz(inputs)
});